module.exports = __webpack_public_path__ + "img/kp.bc049a79.svg";